var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 76,
    viewBox: "0 0 182 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.0897,
    y: 5.42529,
    width: 14.5858,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint0_linear_4_90347)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3105,
    y: 8.34277,
    width: 30.1439,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint1_linear_4_90347)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4763,
    y: 11.2593,
    width: 41.8125,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint2_linear_4_90347)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5591,
    y: 14.1768,
    width: 47.6468,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint3_linear_4_90347)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.642,
    y: 17.0938,
    width: 53.4811,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint4_linear_4_90347)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7249,
    y: 20.0107,
    width: 59.3154,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint5_linear_4_90347)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.78,
    y: 22.9282,
    width: 63.205,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint6_linear_4_90347)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.80762,
    y: 25.8452,
    width: 65.1497,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint7_linear_4_90347)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83527,
    y: 28.7622,
    width: 67.0945,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint8_linear_4_90347)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.86292,
    y: 31.6797,
    width: 69.0393,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint9_linear_4_90347)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.86292,
    y: 34.5967,
    width: 69.0393,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint10_linear_4_90347)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.86292,
    y: 40.4307,
    width: 69.0393,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint11_linear_4_90347)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83527,
    y: 43.3481,
    width: 67.0945,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint12_linear_4_90347)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83527,
    y: 46.2656,
    width: 67.0945,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint13_linear_4_90347)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 10.78,
    y: 49.1821,
    width: 64.1773,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint14_linear_4_90347)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7524,
    y: 52.0996,
    width: 61.2602,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint15_linear_4_90347)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6696,
    y: 55.0171,
    width: 57.3707,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint16_linear_4_90347)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15.642,
    y: 57.9336,
    width: 54.4535,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint17_linear_4_90347)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5591,
    y: 60.8511,
    width: 48.6192,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint18_linear_4_90347)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4763,
    y: 63.7686,
    width: 41.8125,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint19_linear_4_90347)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 28.283,
    y: 66.6851,
    width: 27.2267,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint20_linear_4_90347)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1172,
    y: 69.6025,
    width: 16.5305,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint21_linear_4_90347)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 7.86292,
    y: 37.5142,
    width: 69.0393,
    height: 0.972384,
    rx: 0.486192,
    fill: "url(#paint22_linear_4_90347)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7611 60.8508C39.5337 60.8508 36.5621 60.3358 33.8464 59.3058C31.17 58.2362 28.8282 56.7506 26.8209 54.849C24.8137 52.9079 23.259 50.63 22.157 48.0153C21.0549 45.4007 20.5039 42.5484 20.5039 39.4584C20.5039 36.3683 21.0549 33.516 22.157 30.9014C23.259 28.2868 24.8137 26.0287 26.8209 24.1271C28.8676 22.1859 31.2487 20.7004 33.9645 19.6704C36.6802 18.6007 39.6518 18.0659 42.8792 18.0659C46.3821 18.0659 49.5307 18.6403 52.3252 19.7892C54.0898 20.5046 55.679 21.4274 57.0926 22.5576C58.5405 23.7151 58.4372 25.8531 57.1146 27.1519C55.7388 28.503 53.554 28.4409 51.9449 27.3782C51.1181 26.8322 50.2609 26.3823 49.3733 26.0287C47.5234 25.2364 45.4768 24.8402 43.2334 24.8402C41.0687 24.8402 39.0614 25.1967 37.2115 25.9098C35.3617 26.6229 33.7677 27.6331 32.4295 28.9404C31.0913 30.2477 30.0483 31.7927 29.3005 33.5754C28.5921 35.3581 28.2378 37.3191 28.2378 39.4584C28.2378 41.558 28.5921 43.4992 29.3005 45.2819C30.0483 47.0646 31.0913 48.6294 32.4295 49.9763C33.7677 51.2836 35.342 52.2938 37.1525 53.0069C38.963 53.72 40.9703 54.0765 43.1743 54.0765C45.221 54.0765 47.1889 53.7596 49.0781 53.1258C51.0067 52.4523 52.8368 51.3431 54.5686 49.798L58.9374 55.5621C54.5026 58.5588 54.5026 58.5588 51.3806 59.5435C48.5468 60.415 45.6736 60.8508 42.7611 60.8508ZM51.6758 54.5519V47.1979C51.6758 45.1926 53.3013 43.5671 55.3066 43.5671C57.3118 43.5671 58.9374 45.1926 58.9374 47.1979V49.5646V55.5621L51.6758 54.5519Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.924 44.8069C40.924 43.4644 42.0123 42.376 43.3549 42.376H54.0739C56.7591 42.376 58.9358 44.5527 58.9358 47.2379H43.3549C42.0123 47.2379 40.924 46.1495 40.924 44.8069Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8057 32.996H97.1857V37.1268C96.5746 37.5437 95.8671 37.8637 95.063 38.0868C94.259 38.3098 93.4496 38.4213 92.6348 38.4213C91.4663 38.4213 90.4156 38.1983 89.4829 37.7522C88.5502 37.2965 87.8159 36.671 87.2798 35.8759C86.7545 35.0711 86.4919 34.1644 86.4919 33.156C86.4919 32.1475 86.7545 31.2457 87.2798 30.4506C87.8159 29.6457 88.5556 29.0203 89.499 28.5742C90.4424 28.1185 91.5038 27.8906 92.6831 27.8906C93.6694 27.8906 94.5645 28.0409 95.3686 28.3415C96.1726 28.6421 96.848 29.0785 97.3948 29.6506L95.7224 31.0469C94.9183 30.2809 93.9481 29.8979 92.8117 29.8979C92.0934 29.8979 91.4555 30.0336 90.8981 30.3051C90.3406 30.5766 89.9064 30.9596 89.5955 31.4542C89.2846 31.9487 89.1292 32.516 89.1292 33.156C89.1292 33.7862 89.2846 34.3487 89.5955 34.8432C89.9064 35.3377 90.3352 35.7256 90.882 36.0068C91.4395 36.2783 92.072 36.4141 92.7795 36.4141C93.53 36.4141 94.2054 36.2686 94.8057 35.9777V32.996Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.019 36.065H101.793L100.796 38.2467H98.1262L103.143 28.0652H105.716L110.75 38.2467H108.016L107.019 36.065ZM106.199 34.2759L104.414 30.3778L102.629 34.2759H106.199Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.09 38.2467L116.919 35.4105H114.523V38.2467H111.918V28.0652H116.79C117.787 28.0652 118.65 28.2155 119.379 28.5161C120.119 28.8167 120.687 29.2433 121.084 29.796C121.48 30.3487 121.679 31.0033 121.679 31.7596C121.679 32.516 121.475 33.1705 121.068 33.7232C120.671 34.2662 120.103 34.6832 119.363 34.9741L121.888 38.2467H119.09ZM119.042 31.7596C119.042 31.1875 118.838 30.7512 118.43 30.4506C118.023 30.1403 117.428 29.9851 116.645 29.9851H114.523V33.5341H116.645C117.428 33.5341 118.023 33.379 118.43 33.0687C118.838 32.7584 119.042 32.322 119.042 31.7596Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.918 29.9851H122.315V28.0652H132.125V29.9851H128.523V38.2467H125.918V29.9851Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7116 42.4433H86.4919V41.6545H93.8998V42.4433H90.6801V50.2822H89.7116V42.4433Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.926 49.4934V50.2822H95.4471V41.6545H101.729V42.4433H96.4156V45.5123H101.154V46.2888H96.4156V49.4934H101.926Z",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.13 50.3561C107.223 50.3561 106.402 50.1671 105.669 49.7892C104.945 49.4112 104.374 48.8894 103.955 48.2239C103.545 47.5501 103.34 46.7982 103.34 45.9683C103.34 45.1384 103.545 44.3907 103.955 43.7252C104.374 43.0514 104.95 42.5255 105.683 42.1475C106.416 41.7696 107.236 41.5806 108.143 41.5806C108.824 41.5806 109.452 41.6874 110.028 41.901C110.604 42.1147 111.092 42.4269 111.494 42.8377L110.879 43.417C110.163 42.735 109.26 42.394 108.169 42.394C107.445 42.394 106.786 42.5502 106.193 42.8624C105.6 43.1746 105.133 43.6019 104.793 44.1442C104.461 44.6865 104.295 45.2946 104.295 45.9683C104.295 46.6421 104.461 47.2502 104.793 47.7925C105.133 48.3348 105.6 48.7621 106.193 49.0743C106.786 49.3865 107.445 49.5427 108.169 49.5427C109.269 49.5427 110.172 49.1976 110.879 48.5073L111.494 49.0866C111.092 49.4975 110.599 49.8138 110.015 50.0357C109.439 50.2493 108.811 50.3561 108.13 50.3561Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.215 41.6545V50.2822H120.26V46.3011H114.527V50.2822H113.558V41.6545H114.527V45.5H120.26V41.6545H121.215Z",
    fill: "#1C1C1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.862 41.6545V50.2822H131.064L125.174 43.2814V50.2822H124.205V41.6545H125.004L130.907 48.6552V41.6545H131.862Z",
    fill: "#1C1C1C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.857 50.3561C137.95 50.3561 137.125 50.1671 136.384 49.7892C135.651 49.403 135.075 48.8771 134.656 48.2115C134.246 47.546 134.041 46.7982 134.041 45.9683C134.041 45.1384 134.246 44.3907 134.656 43.7252C135.075 43.0596 135.651 42.5378 136.384 42.1599C137.125 41.7737 137.95 41.5806 138.857 41.5806C139.765 41.5806 140.581 41.7696 141.305 42.1475C142.038 42.5255 142.614 43.0514 143.032 43.7252C143.451 44.3907 143.661 45.1384 143.661 45.9683C143.661 46.7982 143.451 47.5501 143.032 48.2239C142.614 48.8894 142.038 49.4112 141.305 49.7892C140.581 50.1671 139.765 50.3561 138.857 50.3561ZM138.857 49.5427C139.581 49.5427 140.236 49.3906 140.821 49.0866C141.405 48.7744 141.863 48.3471 142.195 47.8048C142.526 47.2543 142.692 46.6421 142.692 45.9683C142.692 45.2946 142.526 44.6865 142.195 44.1442C141.863 43.5937 141.405 43.1664 140.821 42.8624C140.236 42.5502 139.581 42.394 138.857 42.394C138.133 42.394 137.474 42.5502 136.881 42.8624C136.296 43.1664 135.834 43.5937 135.494 44.1442C135.162 44.6865 134.996 45.2946 134.996 45.9683C134.996 46.6421 135.162 47.2543 135.494 47.8048C135.834 48.3471 136.296 48.7744 136.881 49.0866C137.474 49.3906 138.133 49.5427 138.857 49.5427Z",
    fill: "#1C1C1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.832 41.6545H146.8V49.4934H151.931V50.2822H145.832V41.6545Z",
    fill: "#1C1C1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.365 50.3561C156.457 50.3561 155.633 50.1671 154.891 49.7892C154.158 49.403 153.582 48.8771 153.164 48.2115C152.753 47.546 152.548 46.7982 152.548 45.9683C152.548 45.1384 152.753 44.3907 153.164 43.7252C153.582 43.0596 154.158 42.5378 154.891 42.1599C155.633 41.7737 156.457 41.5806 157.365 41.5806C158.272 41.5806 159.088 41.7696 159.812 42.1475C160.545 42.5255 161.121 43.0514 161.54 43.7252C161.959 44.3907 162.168 45.1384 162.168 45.9683C162.168 46.7982 161.959 47.5501 161.54 48.2239C161.121 48.8894 160.545 49.4112 159.812 49.7892C159.088 50.1671 158.272 50.3561 157.365 50.3561ZM157.365 49.5427C158.089 49.5427 158.743 49.3906 159.328 49.0866C159.913 48.7744 160.371 48.3471 160.702 47.8048C161.034 47.2543 161.2 46.6421 161.2 45.9683C161.2 45.2946 161.034 44.6865 160.702 44.1442C160.371 43.5937 159.913 43.1664 159.328 42.8624C158.743 42.5502 158.089 42.394 157.365 42.394C156.641 42.394 155.982 42.5502 155.389 42.8624C154.804 43.1664 154.341 43.5937 154.001 44.1442C153.67 44.6865 153.504 45.2946 153.504 45.9683C153.504 46.6421 153.67 47.2543 154.001 47.8048C154.341 48.3471 154.804 48.7744 155.389 49.0866C155.982 49.3906 156.641 49.5427 157.365 49.5427Z",
    fill: "#1C1C1C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.792 45.9683H171.721V49.2592C171.293 49.6125 170.787 49.8837 170.203 50.0726C169.618 50.2616 169.003 50.3561 168.357 50.3561C167.441 50.3561 166.616 50.1671 165.884 49.7892C165.151 49.4112 164.575 48.8894 164.156 48.2239C163.737 47.5501 163.528 46.7982 163.528 45.9683C163.528 45.1384 163.737 44.3907 164.156 43.7252C164.575 43.0514 165.151 42.5255 165.884 42.1475C166.616 41.7696 167.445 41.5806 168.37 41.5806C169.068 41.5806 169.71 41.6874 170.294 41.901C170.879 42.1064 171.372 42.4146 171.773 42.8254L171.171 43.4047C170.447 42.7309 169.526 42.394 168.41 42.394C167.668 42.394 166.996 42.5502 166.394 42.8624C165.801 43.1664 165.334 43.5937 164.994 44.1442C164.653 44.6865 164.483 45.2946 164.483 45.9683C164.483 46.6421 164.653 47.2502 164.994 47.7925C165.334 48.3348 165.801 48.7621 166.394 49.0743C166.987 49.3865 167.655 49.5427 168.396 49.5427C169.339 49.5427 170.137 49.3208 170.792 48.8771V45.9683Z",
    fill: "#1C1C1C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.603 47.2995V50.2822H176.648V47.2995L172.983 41.6545H174.017L177.158 46.4983L180.299 41.6545H181.268L177.603 47.2995Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_90347",
    x1: 50.6478,
    y1: 4.45291,
    x2: 33.6311,
    y2: 5.91148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_90347",
    x1: 59.464,
    y1: 7.37039,
    x2: 25.1156,
    y2: 13.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_90347",
    x1: 66.0763,
    y1: 10.2869,
    x2: 19.7345,
    y2: 21.6737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_90347",
    x1: 69.3824,
    y1: 13.2044,
    x2: 17.457,
    y2: 27.7435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_90347",
    x1: 72.6885,
    y1: 16.1214,
    x2: 15.4857,
    y2: 34.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_90347",
    x1: 75.9946,
    y1: 19.0384,
    x2: 13.8371,
    y2: 40.7047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_90347",
    x1: 78.1987,
    y1: 21.9558,
    x2: 12.9231,
    y2: 46.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_90347",
    x1: 79.3007,
    y1: 24.8728,
    x2: 12.5225,
    y2: 50.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_90347",
    x1: 80.4027,
    y1: 27.7898,
    x2: 12.1598,
    y2: 54.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_90347",
    x1: 81.5048,
    y1: 30.7073,
    x2: 11.8351,
    y2: 58.9733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_90347",
    x1: 81.5048,
    y1: 33.6243,
    x2: 11.8351,
    y2: 61.8903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.312243,
    stopColor: "#32E1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#564CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_90347",
    x1: 81.5048,
    y1: 39.4583,
    x2: 11.8351,
    y2: 67.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_90347",
    x1: 80.4027,
    y1: 42.3758,
    x2: 12.1598,
    y2: 69.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_90347",
    x1: 80.4027,
    y1: 45.2932,
    x2: 12.1598,
    y2: 72.2004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_90347",
    x1: 79.2359,
    y1: 48.2097,
    x2: 13.2043,
    y2: 73.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_90347",
    x1: 77.0966,
    y1: 51.1272,
    x2: 13.3614,
    y2: 74.0719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_90347",
    x1: 75.8649,
    y1: 54.0447,
    x2: 15.3223,
    y2: 74.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_90347",
    x1: 73.7257,
    y1: 56.9612,
    x2: 15.6743,
    y2: 75.5376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_90347",
    x1: 70.4196,
    y1: 59.8787,
    x2: 17.5929,
    y2: 74.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_90347",
    x1: 66.0763,
    y1: 62.7962,
    x2: 19.7345,
    y2: 74.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_90347",
    x1: 57.3248,
    y1: 65.7127,
    x2: 26.1256,
    y2: 70.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_90347",
    x1: 51.7498,
    y1: 68.6302,
    x2: 32.5041,
    y2: 70.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_90347",
    x1: 81.5048,
    y1: 36.5418,
    x2: 11.8351,
    y2: 64.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734118,
    stopColor: "#564CEC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0bd5a41ddadce93c7c0cf6d8fa4fd50f.svg";
export { ForwardRef as ReactComponent };